import A11yHiddenBox from '@rover/kibble/styles/A11yHiddenBox';
import { getAbsoluteUrl } from '@rover/shared/js/utils/getFullUrl';

import MicrodataHTMLAttributes from './MicrodataHTMLAttributes';
import schema from './schema';

type Props = {
  localityType: 'city' | 'neighborhood';
  cityName: string;
  url?: string;
  name: string;
  regionName: string;
  countryCode?: string;
  postalCode?: string;
} & MicrodataHTMLAttributes;

const PostalAddress: React.FC<Props> = ({
  localityType,
  name,
  cityName,
  regionName,
  url,
  countryCode,
  postalCode,
  ...props
}: Props) => (
  <A11yHiddenBox {...props} webProps={{ itemScope: true, itemType: schema`PostalAddress` }}>
    {localityType === 'neighborhood' ? (
      <>
        <meta itemProp="name" content={name} />
        <meta itemProp="addressLocality" content={cityName} />
      </>
    ) : (
      <meta itemProp="addressLocality" content={cityName} />
    )}
    <meta itemProp="addressRegion" content={regionName} />
    {countryCode && <meta itemProp="addressCountry" content={countryCode} />}
    {postalCode && <meta itemProp="postalCode" content={postalCode} />}
    {url ? <meta itemProp="sameAs" content={getAbsoluteUrl(url).toString()} /> : null}
  </A11yHiddenBox>
);

export default PostalAddress;
